<template>
    <q-page-container>
        <slot />
    </q-page-container>
</template>

<script>
export default {}
</script>

<style></style>
